const constants = {
  whiteRequestList: [ // 请求白名单
    '/login'
  ]
};
export default constants;
